import React, { useEffect } from 'react'
import HelpCenterLayout from '../../components/Help/HelpCenterLayout'

const HelpCenter = () => {
  useEffect(()=>{ window.scrollTo(0,0); },[])
  return (
    <>
      <HelpCenterLayout />
    </>
  )
}

export default HelpCenter